import React, { useState } from 'react';
import { FiMaximize } from 'react-icons/fi';
import BridgeRequestModal from './BridgeRequestModal';

export default function BotonEscanear({ onScan, size = 18, style, title = 'Escanear código con el celular' }) {
  const [abierto, setAbierto] = useState(false);

  const handleResultado = (resultado) => {
    const codigo = resultado?.resultado?.codigo || resultado?.codigo;
    if (codigo && onScan) onScan(codigo);
  };

  return (
    <>
      <button
        type="button"
        title={title}
        onClick={() => setAbierto(true)}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '6px',
          borderRadius: '10px',
          border: '1px solid var(--agx-border)',
          background: 'var(--agx-bg)',
          color: 'var(--agx-muted)',
          cursor: 'pointer',
          transition: 'all 0.15s',
          flexShrink: 0,
          ...style,
        }}
      >
        <FiMaximize size={size} />
      </button>
      <BridgeRequestModal
        open={abierto}
        onClose={() => setAbierto(false)}
        tipo="escanear_codigo"
        titulo="Escanear código con el celular"
        onResultado={handleResultado}
      />
    </>
  );
}
